<template>
    <select
        class="large"
        v-model="selectedOption"
        @change="setOption"
    >
        <option
            v-for="option in options"
            :value="option"
            :selected="selectedOption === option"
        >{{ option }}</option>
    </select>
</template>

<script>
    export default {
        props: {
            options: {
                type: Array,
                required: true
            },
        },
        data: () => ({
            selectedOption: null,
        }),
        methods: {
            setOption() {
                this.$emit('selected', this.selectedOption)
            }
        },
    }
</script>

<style scoped>

</style>
